/*

zie voor meer basic uitleg over de datepicker ../src/datepicker.php

voor time-only pickers:
	Moment.js kan niet omgaan met alleen time, het moet een datetime zijn.
	Daarom zetten we de datum altijd op vandaag, en passen de tijd aan.

Als je zelf via JS een start/eind datepicker neer ga zetten, dan MOET het startID als eerste worden meegegeven aan opts.inputids

---------

TODO:

- landscape view on iphone is very bad (seems to be a bug in safari ios)
- Saves the states of the datepickers in window.iddDatePicker
- css:hover should be disabled on touchy devices (it looks ugly on your mobile)

---------

Example usage:

	const opts = {
		inputIDs: ['startdate','enddate'],
		dates: [

			{
			name:     'Start date',
			propName: 'startDate',
			date:      null,
			colors:    {color: '#080', background: '#fff'},
			},

			{
			name:     'Completion date',
			propName: 'completionDate',
			date:      null,
			colors:    {color: '#008', background: '#fff'},
			presetRelative: true,
			},
		],
		showDatePanel: true,
		defaultPresets: true,
		hooks: {
			onSelect: onSelectHook,
			onSave: onSaveHook,
			onCancel: onCancelHook,
		}
	}

	function onSelectHook(data) {
		console.log(data,"onSelectHook");
	}

	function onSaveHook(data) {
		console.log(data,"onSaveHook");
	}

	function onCancelHook(data) {
		console.log(data,"onCancelHook");
	}

	// render the datepicker
	// ?

*/


(function(root, factory) {
	'use strict';
	
	if (typeof define === 'function' && define.amd) {
		// AMD. Register as a named module.
		define('idd/datepicker', ['hyperhelper', 'morphdom-opts', 'idd/locutus/php/datetime/strtotime'], factory);
	} else {
		// Browser globals
		root.DatePicker = factory(root.hyperhelper, root.MORPHDOM_OPTS, root.locutus.php.datetime);
	}
	
}(this, function(hyperhelper, MORPHDOM_OPTS, strtotime) {
	
	'use strict';
	
	// Define objects that are used
	var div    = hyperhelper.div;
	var span   = hyperhelper.span;
	var label  = hyperhelper.label;
	var a      = hyperhelper.a;
	var button = hyperhelper.button;
	

	// Add some namespaces for the plethora of functions we have.
	var DatePicker = {};
	
	var overlay = div("#idd-datepicker-overlay");
	document.body.appendChild(overlay);
		
	DatePicker.varants = {};
	DatePicker.varants.WeekdaysShort = ["Mo", "Tu", "We", "Th", "Fr", "Sa", "Su"];
	DatePicker.varants.CSSPrefix = '.idd-datepicker';
	
	DatePicker.Config = {};
	DatePicker.DOM = {};
	DatePicker.Events = {};
	DatePicker.Util = {};
	DatePicker.Public = {};
	DatePicker.State = {};
	
	DatePicker.Config._datePickerCounter = 0;

	DatePicker.Config.validateAndMergeDefaults = function(opts) {
	
		const defaults = {
			dates: {
				name:        'Date',
				propName:    'date',
				date:        null,
				colors:      {color: 'white', background: 'hsl(185, 100%, 35%)'}
			},
			format:          'YYYY-MM-DD HH:mm',
			yearMin:         1900,
			yearMax:         2100,
			position:        {top: 0, left: 0},
			viewTimeSpan:    {type: 'month', delta: 1},
			align:           'bottom',
			selectedDateIdx: 0,
			showDatePanel:   true,
			showDate:        true,
			showTime:        true,
			showAbsolutePresets: true,
			showRelativePresets: true,
		};
			
		// merge defaults with options
		opts = Object.assign(defaults, opts);
		
		if (!opts.id) {
			
			// als er geen ID is meegegeven maar wel een input veld, dan gaan we zelf een div maken met een nieuw ID.
			if (opts.inputIDs) {
				opts.id = 'datepicker_auto'+DatePicker.Config._datePickerCounter++;
				
				var newContainer = div({id: opts.id});
				
				document.body.appendChild(newContainer);
				
			} else {
				console.warn("opts should have an identifier 'id' or input fields");
			}
		}
	
		// Check if propNames are unique
		//var propNames = opts.dates.map(x => x.propName);
		var propNames = opts.dates.map(function(x) {
			return x.propName;
		});
		
		var unique = propNames.filter(function(v, i, a){ 
			return a.indexOf(v) === i;
		});
		
		if (propNames.length !== unique.length) {
			console.warn("propNames of dates are not unique", propNames);
		}
	
		// als er inputIDs zijn meegegeven, dan gaan we de datums uit de input velden uitlezen en die in de opts doen
		if (opts.inputIDs) {
			
			opts.inputIDs.forEach(function(id, index) {
				var element = document.getElementById(id);
				
				// alleen doen als ze nog niet ingevuld (door bijvoorbeeld de autoGenerator) en als de velden gevuld zijn
				if (opts.dates[index].length == 0 && element.value !== "" && element.value !== undefined) {
					var dateValue = moment(element.value);
					if (dateValue.isValid() && dateValue.year() >= opts.yearMin && dateValue.year() <= opts.yearMax) {
						opts.dates[index].date = dateValue;
					}
				}
			});
		}
		
		// If we want default presets
		if (opts.defaultPresets) {
			opts.presets = DatePicker.Config.getDefaultPresets();
		}

		// Validate year bounds
		if (opts.yearMax < opts.yearMin) {
			opts.yearMin = defaults.yearMin;
			opts.yearMax = defaults.yearMax;
		}
		
		// Select date if specified, or now
		opts.selectedDate = opts.dates[0];
		var date = opts.selectedDate.date || moment();
		// Limit date to year bounds
		if (date.year() < opts.yearMin) {
			date = moment().year(opts.yearMin).startOf('year');
		}
		if (date.year() > opts.yearMax) {
			date = moment().year(opts.yearMax).endOf('year');
		}

		// The currently selected date should be rounded to the nearest
		// five-minute increment.
		date.add(30, 's').minutes(Math.round(date.minutes() / 5) * 5).startOf('minute');

		opts.selected     = DatePicker.Util.splitDateParts(date);
		opts.view         = DatePicker.Util.splitDateParts(date);

		// Store opts in the Config object
		return this.opts = opts;
	};
	
	
	
	/* ----------------- DatePicker.Public -------------------- */
	
	DatePicker.Public.render = function(opts) {
		
		opts = DatePicker.Config.validateAndMergeDefaults(opts);
		
		// rename id to instanceID and remove id from the options object
		var instanceID = opts.id;
		opts.instanceID = opts.id;
		delete opts.id;
	
		// set all the options to the state
		DatePicker.State.set(instanceID, opts);
		
		var container = DatePicker.DOM.renderDatePicker(instanceID);
		
		// code for when we apply the datepicker to an input field (which is always except for DOT)
		// make the datepicker pop up when we select an input field
		if (opts.inputIDs) {
			
			var aInputIDs = [];
			
			opts.inputIDs.forEach(function(id) {
				aInputIDs.push(document.getElementById(id));
			});
			
			aInputIDs.forEach(function(inputField, index) {
				const inputWidth                = inputField.offsetWidth;
				const inputWidthWithoutCalendar = inputWidth - 23;// 23px klikbaar voor het openen van de datepicker.
				
				// Geef feedback bij hover met een background en handje als cursor.
				inputField.addEventListener("mousemove", function(event) {
					const inputHoverPosition = event.offsetX;
					
					if (inputHoverPosition > inputWidthWithoutCalendar) {
						inputField.style.cursor    = "pointer";
						inputField.style.boxShadow = "inset -23px 0 hsl(212, 90%, 53%, .2)";
					} else {
						inputField.style.cursor    = null;
						inputField.style.boxShadow = null;
					}
				});

				// Trek feedback terug bij verlaten van input.
				inputField.addEventListener("mouseleave", function() {
					inputField.style.cursor    = null;
					inputField.style.boxShadow = null;
				});

				inputField.addEventListener("click", function(event) {
					const inputClickPosition = event.offsetX;
					
					if (inputClickPosition > inputWidthWithoutCalendar) {
						// if you click on a datepicker while another datepicker is active, close the previous one
						if (instanceID != window.iddDatePicker.activeInstanceID) {
							DatePicker.Public.hide(window.iddDatePicker.activeInstanceID);
						}
						
						var state = DatePicker.State.get(instanceID);
						
						// if focus on the inputfield for enddate we want the second tab of the datepicker to open
						state.selectedDateIdx = index;
						state.selectedDate    = state.dates[index];
						
						// als er geen date is (omdat je op clearDate hebt gedrukt), dan de huidige datum aannemen
						if (state.selectedDate.date == null) state.selectedDate.date = moment();
						
						state.selected        = DatePicker.Util.splitDateParts(state.selectedDate.date);
						state.view            = state.selected;
						state.selectedInputID = state.inputIDs[index];
						
						inputField.blur();
						DatePicker.Public.showOverlay();
						DatePicker.Public.redraw(instanceID, inputField);
					}
				});
			});
		}
		return container;
	};
	
	document.addEventListener('click', function(event) {
		
		// Controleer of er een datepicker is anders krijg je foutmelding.
		if (document.querySelector(".idd-datepicker") === null) {
			return;
		}
		
		var instanceID = window.iddDatePicker.activeInstanceID;
		var filledContainer = document.getElementById(instanceID);
		
		// als we op een relative preset klikken vanuit de startdatum, dan stellen we de einddatum in.
		// omdat we die instellen, gaan we ook naar die datetab, waardoor de node verdwijnt waar we net geklikt
		// op hebben. daarom zal deze node geen parent meer hebben, omdat deze net door morphdom is weggehaald.
		// om dit op te lossen, gaan we _ook_ kijken naar de classname van de geklikte node.
		// (eigenlijk een beetje een hack...)
		var hasClassDatepicker = false;
		event.target.classList.forEach(function(classname) {
			if (classname.indexOf('idd-datepicker') != -1) {
				hasClassDatepicker = true;
			}
		});
		
		// if a click is outside the datepicker AND outside an input field
		if (!containsParent(event.target, filledContainer) && !hasClassDatepicker) {
			DatePicker.Public.hide(instanceID);
		}
	});
	
	DatePicker.Public.hide = function(instanceID) {
		
		// hide datepicker
		var container = document.getElementById(instanceID);
		container.style.display = "none";
		
		// de input blurren waar je op geklikt had. vooral belangrijk voor mobiel/ipad
		var state = DatePicker.State.get(instanceID);
		if (state.selectedInputID !== undefined) {
			DatePicker.Util.validateInput(state.selectedInputID);
			document.getElementById(state.selectedInputID).blur();
			state.selectedInputID = undefined;
		}
		
		DatePicker.Public.hideOverlay();
	};
	
	DatePicker.Public.showOverlay = function() {
		document.getElementById("idd-datepicker-overlay").style.display = "block";
	};
	
	DatePicker.Public.hideOverlay = function() {
		document.getElementById("idd-datepicker-overlay").style.display = "none";
	};
	
	DatePicker.Public.redraw = function(instanceID, inputField) {

		// Get an element from the page to append it to
		var wrapper = document.getElementById(instanceID);
		var container = DatePicker.DOM.renderDatePicker(instanceID);
		
		// we provide morphdomopts because the onclick events won't morph automatically
		var node = morphdom(wrapper, container, MORPHDOM_OPTS);
		
		if (inputField) {
			DatePicker.Util.calculateCalenderPos(inputField);
		}
		
		DatePicker.DOM.setCalenderPos(node);
	};
	
	/*----------------- DatePicker.DOM -------------------- */
	
	DatePicker.DOM.mount = function(containerId) {
		var container = document.getElementById(containerId);
		var node      = morphdom(container, this);
		
		DatePicker.Util.calculateCalenderPos(node);
		DatePicker.DOM.setCalenderPos(container);
	};
	
	
	DatePicker.DOM.renderDatePicker = function(instanceID) {

		DatePicker.State.setActiveInstanceID(instanceID);
		var state = DatePicker.State.get(instanceID);

		var datepickerContent = [];

		if (state.showDate && state.showDatePanel) {
			datepickerContent = [
				DatePicker.DOM.renderDateDuration(state),
				div(_cls('tabGroup'),state.dates.map(date => DatePicker.DOM.renderDateTab(state, date)))
			];
		}

		// disable navigation outside year bounds
		var classPrev = _cls('prev');
		var classNext = _cls('next');
		var clickPrev = DatePicker.Events.prevButtonClick;
		var clickNext = DatePicker.Events.nextButtonClick;
		switch (state.viewTimeSpan.type) {
		case "years":
			if (state.view.year < state.yearMin) {
				state.view = DatePicker.Util.splitDateParts(state.view.obj.clone().year(state.yearMin));
			}
			if (state.view.year > state.yearMax) {
				state.view = DatePicker.Util.splitDateParts(state.view.obj.clone().year(state.yearMax));
			}
			// fall through
		case "year":
			if (Math.floor(state.view.year / state.viewTimeSpan.delta) <= Math.floor(state.yearMin / state.viewTimeSpan.delta)) {
				classPrev += _cls('disabled');
				clickPrev = null;
			}
			if (Math.floor(state.view.year / state.viewTimeSpan.delta) >= Math.floor(state.yearMax / state.viewTimeSpan.delta)) {
				classNext += _cls('disabled');
				clickNext = null;
			}
			break;
		case "month":
			if (state.view.year < state.yearMin || state.view.year == state.yearMin && state.view.month == 1) {
				classPrev += _cls('disabled');
				clickPrev = null;
			}
			if (state.view.year > state.yearMax || state.view.year == state.yearMax && state.view.month == 12) {
				classNext += _cls('disabled');
				clickNext = null;
			}
			break;
		}

		datepickerContent.push(div(_cls('calendar'),
						[
							div(_cls('nav'),
							div(_cls('headerTitles'),
							span(_cls('monthtitle'), state.view.monthName, {onclick: DatePicker.Events.monthTitleClick}),
							span(_cls('yeartitle'),  state.view.year,      {onclick: DatePicker.Events.yearTitleClick})),
							
							div(_cls('headerArrows'),
							span(classPrev,          '<',                  {onclick: clickPrev}),
							span(classNext,          '>',                  {onclick: clickNext}))
						),
							DatePicker.DOM.renderMonthView(state),
							DatePicker.DOM.renderYearView(state),
							DatePicker.DOM.renderYearsView(state)
						])
		);

		// Losse variable nodig voor mogelijk toevoegen type datepicker
		var datepickerContentClass = DatePicker.varants.CSSPrefix;

		// Voeg timepicker toe
		if (state.showTime) {
			datepickerContent.push(DatePicker.DOM.renderTimeView(state));
			datepickerContentClass = datepickerContentClass + '.idd-timepicker';
		}

		// Voeg startendpicker toe
		if (state.presets) {
			datepickerContent.push(DatePicker.DOM.renderPresetsView(state));
			datepickerContentClass = datepickerContentClass + '.idd-startendpicker';
		}
	
		// Make a iddDatepicker around the array
		var iddDatepicker = div(datepickerContentClass, 
			{
				id: instanceID,
				'data-id': instanceID
			}, 
			datepickerContent
		);
	
		iddDatepicker.mount = DatePicker.DOM.mount;
	
		return iddDatepicker;
	};
	
	
	DatePicker.DOM.updateInputField = function(date, idx) {
		var instanceID = DatePicker.State.getActiveInstanceID();
		var state = DatePicker.State.get(instanceID);
		
		// retrieve the ID of the inputfield you selected and update its value
		var inputField = document.getElementById(state.inputIDs[idx]);
		
		// Check if there is any input.
		if (date == "") {
			inputField.value = "";
		} else {
			if (!state.showDate) {// Only show time.
				inputField.value = moment(date).format('HH:mm');

			} else if (!state.showTime) {// Show date only and set full days.
				inputField.value = moment(date).format('YYYY-MM-DD');

			} else {// Show time and date.
				inputField.value = moment(date).format('YYYY-MM-DD HH:mm');
			}
		}
		
		DatePicker.Util.validateInput(state.inputIDs[idx]);
		
		// Aangeven dat het input element is aangepast.
		// Dit is belangrijk wanneer andere code daarop moet reageren.
		inputField.dispatchEvent(new Event('change'));
	};
		
	// Sets the position of the calendar container
	DatePicker.DOM.setCalenderPos = function(container) {
		var instanceID = DatePicker.State.getActiveInstanceID();
		var state = DatePicker.State.get(instanceID);
		
		container.style.top = state.position.top + "px";
		container.style.left = state.position.left + "px";
	};
	
	DatePicker.DOM.renderDateTab = function(state, date) {

		var addCss = (date == state.selectedDate) ? '.active-date.active' : '.inactive-date';
	
		// Check if date is null or set
		var strDate;
		if (date.date instanceof String) {
			// FIXME? dit wordt nooit gebruikt
			strDate = date.date;
		} else if (date.date !== null) {
			// Check which value must be displayed.
			if (!state.showDate) {
				strDate = date.date.format("HH:mm");// Only time
			} else if (!state.showTime) {
				strDate = date.date.format("YYYY MMM D");// Only date
			} else {
				strDate = date.date.format("YYYY MMM D, HH:mm");// Full date + time
			}
			
			//.datetab-date-value: 1. Year, 2. Month, 3. Year, 4. Time
			var strDate = strDate.match(/^(\S+)\s(.*)/).slice(1);
			
			var strDateYear = strDate[0];
			var strDateRest = strDate[1];
		} else {
			var strDateYear = '';
			var strDateRest = 'No Date';
		}
		
		var clearBtn = date.date ? button('.clearBtn', "clear", {onclick: DatePicker.Events.clearBtnClick}) : '';
	
		var dateTab = div(
			_cls('tab') + addCss,
			{
				'data-propname': date.propName,
				'onclick': DatePicker.Events.dateTabClick
			},
			span('.tab-row', span('#tab-top-date', strDateYear), span('#tab-title', date.name)),
			span('.tab-row', span('#tab-bottom-date', strDateRest), clearBtn)
		);
		
		return dateTab;
	};

	DatePicker.DOM.renderDateDuration = function(state) {
		var date0      = state.dates[0].date;
		var date1      = state.dates[1].date;
		var dateLast   = state.dates[state.dates.length-1].date;

		var durationAB = label('Duration of ', moment.duration(date1 - date0).humanize());
		if (moment(date0).format() == 'Invalid date' || moment(date1).format() == 'Invalid date') {
			durationAB = label('-');
		}
		
		if (state.dates.length == 3) {
			if (moment(date1).format() == 'Invalid date' || moment(dateLast).format() == 'Invalid date') {
				var durationBC = label('-');
			} else {
				durationBC = label(moment.duration(dateLast - date1).humanize());
			}
		}

		return div(_cls('duration'), durationAB, durationBC);
	};

	// Output the month object
	DatePicker.DOM.renderMonthView = function(state) {
		var title = DatePicker.DOM.renderWeekDaysTitle();
		var rows  = DatePicker.DOM.renderWeekDaysRows(state);
	
		// Whether we are in the right viewmode
		var displayStyle = '';
		if (state.viewTimeSpan.type != 'month') {
			displayStyle = _cls('hide');
		}
	
		return div(_cls('view-days') + displayStyle, title, rows);
	};
	
	
	// Make a row of all weekdays
	DatePicker.DOM.renderWeekDaysTitle = function() {
		// we willen dat moment op maandag begint
		// dat kan met een global moment setting, maar dan passen we ook de agenda daarmee aan (die gebruikt ook moment)
		// daarom gewoon handmatig de namen van de dagen erin zetten
		var weekDays = DatePicker.varants.WeekdaysShort.map(function(day) {
			return span(_cls('weekday'), day);
		});
		
		return div(_cls('weekdays'), weekDays);
	};
	
	
	// Make an array of rows of all the days in the week
	DatePicker.DOM.renderWeekDaysRows = function(state) {
		var weekRow = [];
		
		var time         = state.view.obj.clone();
		var startOfMonth = time.clone().startOf('month').startOf('isoWeek');
		var firstWeek    = time.clone().startOf('month').startOf('isoWeek');
		var lastWeek     = time.clone().endOf('month').endOf('isoWeek');
		var currentWeek  = firstWeek.clone();

		var dates     = state.dates;
		var startDate = dates[0];
		var endDate   = dates[1];
		
		var deltaDay = 0;
		while (currentWeek.valueOf() < lastWeek.valueOf()) {
			
			// Number of the day
			var dayObj = [];
			var weekNumberBetween = '';
			for (var i = 0; i < 7; i++) {
				
				//Recalculate the day
				var dayCell = startOfMonth.clone().add(deltaDay, 'd');
				var dayCellFormat = dayCell.format('YYYY-MM-DD');
				
				// Check what type of cell it is.
				var cellType = '';
				var cellToday = '';
				var cellStyle = '';
				var isDisabled = false;
				dates.map(function(date) {
					
					// Check if out of year bounds
					if (dayCell.year() < state.yearMin || dayCell.year() > state.yearMax) {
						isDisabled = true;
						return;
					}

					// Check if cell is today
					if (dayCellFormat === moment().format('YYYY-MM-DD')) {
						cellToday = '-today';
					}
					
					// Check if cell is in weekend
					if (dayCell.day() === 0 || dayCell.day() === 6) {
						cellStyle = {'color': 'hsl(0, 0%, 55%)'};
					}
					
					// Check if cell is in month
					if (dayCell.month() + 1 !== state.view.month) {
						cellStyle = {'color': 'hsl(0, 0%, 85%)'};
					}
					
					// Check if datepicker is single or start-end.
					if (!endDate) {
						if (date.date.format('YYYY-MM-DD') === dayCellFormat) {
						    cellStyle = {'color': 'white',
						                 'background-color': 'hsl(210, 100%, 50%)'
						                };
						}
						return;
						
					} else {
						var startDay = startDate.date.format('YYYY-MM-DD');
						var endDay = endDate.date.format('YYYY-MM-DD');

						// Check if the START and END are in the same cell.
						if (dayCellFormat === startDay && dayCellFormat === endDay) {
							cellStyle = {'color': 'white',
										'background-color': 'hsl(210, 100%, 50%)'
										};
							return;
						}
						// Check if cell is START date.
						if (dayCellFormat === startDay) {

							var startTimePart = (state.showTime) ? startDate.date.format('HH') * 4 + '%' : '0%';

							cellType = '-start';
							cellStyle = {
									 'background':'linear-gradient(100deg,hsl(210, 100%, 80%)              0%' +
																		',hsl(210, 100%, 80%)' + startTimePart +
																		',hsl(210, 100%, 60%)' + startTimePart +
																		',hsl(210, 100%, 60%)           100%)'
																		};
						// Check if cell is between START and END date.
						} else if (dayCellFormat > startDay && dayCellFormat < endDay) {
							cellType = '-between';
							cellStyle = {'color':'white'};
							
						// Check if cell is END date.
						} else if (dayCellFormat === endDay) {

							var endTimePart = (state.showTime) ? endDate.date.format('HH') * 4 + '%' : '0%';
							
							cellType = '-end';
							cellStyle = {
								background: 'linear-gradient(100deg,hsl(210, 100%, 60%) 0%' +
								            ',hsl(210, 100%, 60%)' + endTimePart +
								            ',hsl(210, 100%, 80%)' + endTimePart +
								            ',hsl(210, 100%, 80%)         100%)'
							};
						}
					}
					// Check if first day of week is a end of between cell
					if ((cellType == '-end' || cellType == '-between') && i === 0) weekNumberBetween = '-between';
				});
				
				// Number of the week
				var weekNumber = span(
					_cls('cell') + _cls('cell-day-weekNumber' + weekNumberBetween),
					{ 
						'data-week': currentWeek.isoWeek(),
						'data-year': currentWeek.year()
					},
					currentWeek.isoWeek()
				);
				
				// ===== End Styling ===== \\
				dayObj.push(span(
					_cls('cell') + _cls('cell-day' + cellType + cellToday) + (isDisabled ? _cls('disabled') : ''),
					{ 
						'data-year':  dayCell.year(),
						'data-month': dayCell.month() + 1,
						'data-day':   dayCell.date(),
						onclick: isDisabled ? null : DatePicker.Events.dayClick,
						'style': cellStyle
					},
					dayCell.date()
				));
				deltaDay++;
			}
			
			// Add the weeknumber to the dayObj
			dayObj.unshift(weekNumber);
			
			weekRow.push(div(_cls('grid-row'), dayObj));
			
			currentWeek.add(1, 'weeks');
		}
	
		return weekRow;
	};
	
	// Output the time object
	DatePicker.DOM.renderTimeView = function(state) {
		var hours   = DatePicker.DOM.renderHoursView(state);
		var minutes = DatePicker.DOM.renderMinutesView(state);
	
		// Whether we are in the right viewmode
		var displayStyle = '';
		if (state.viewTimeSpan.type != 'month') {
			displayStyle = _cls('hide');
		}
	
		return div(_cls('time') + displayStyle, hours, minutes);
	};
	
	
	// Output the hours object
	DatePicker.DOM.renderHoursView = function(state) {
		var titleObj   = div(_cls('time-title'), 'Hours');
	
		var outObj  = [];
		var vertObj = [];
		var horObj  = [];
		
		var hoursHor = 6;
		var hour = 0;
		while (hour < 23) {
			for (var i = 0; i < hoursHor; i++) {
				
				var inlineStyleSelected = [];
				if (hour == state.selected.hour) {
					inlineStyleSelected = {'color': 'white',
						                 'background-color': 'hsl(210, 100%, 50%)'
						                };
				}
				
				var strHour = DatePicker.Util.pad0(hour);
				
				var hourObj = span(
					_cls('cell') + _cls('cell-hour'),
					{
						'data-hour': hour,
						onclick: DatePicker.Events.hourClick,
						'style': inlineStyleSelected
					},
					strHour
				);
				
				horObj.push(hourObj);
				hour++;
			}
	
			vertObj = div(_cls('grid-row'), horObj);
			outObj.push(vertObj);
		}
	
		return div(
			_cls('time-hours'),
			titleObj,
			outObj
		);
	};
	
	
	// Output the minutes object
	DatePicker.DOM.renderMinutesView = function(state) {
		var titleObj = div(_cls('time-title'), 'Minutes');
	
		var outObj  = [];
		var vertObj = [];
		var horObj  = [];
	
		var deltaMinutes = 5;
		var minutesHor   = 3;
	
		var minute = 0;
		while (minute < 55) {
			for (var i = 0; i < minutesHor; i++) {
	
				var inlineStyleSelected = [];
				if (minute == Math.ceil(state.selected.minutes/deltaMinutes)*deltaMinutes) {
					inlineStyleSelected = {'color': 'white',
						                 'background-color': 'hsl(210, 100%, 50%)'
						                };
				}
			
				var strMinute = DatePicker.Util.pad0(minute);
				var minuteObj = span(
					_cls('cell') + _cls('cell-minute'),
					{
						'data-minutes': minute,
						onclick: DatePicker.Events.minuteClick,
						'style': inlineStyleSelected
					},
					strMinute
				);
				
				horObj.push(minuteObj);
				minute += deltaMinutes;
			}
	
			vertObj = div(_cls('grid-row'), horObj);
			outObj.push(vertObj);
		}
	
		return div(
			_cls('time-minutes'),
			titleObj,
			outObj
		);
	};
	
	
	DatePicker.DOM.renderYearView = function(state) {
		var outObj  = [];
		var vertObj = [];
		var horObj  = [];
	
		var strMonths = moment.monthsShort();
		var monthsHor = 4;
	
		// January is the first month, we have to be careful with our indices and monthnumber
		var month = 1;
		var numMonths = strMonths.length;
		while (month < numMonths) {
			for (var i = 0; i < monthsHor; i++) {
				var monthObj = span(
									  _cls('cell') + _cls('cell-month'),
									  {
										  'data-month': month,
										  onclick: DatePicker.Events.monthClick
									  },
									  strMonths[month-1]
									  );
	
				horObj.push(monthObj);
				month++;
			}
	
			vertObj = div(_cls('grid-row'), horObj);
			outObj.push(vertObj);
		}
	
		// Whether we are in the right viewmode
		var displayStyle = '';
		
		if (state.viewTimeSpan.type != 'year') {
			displayStyle = _cls('hide');
		}
		return div(_cls('view-months') + displayStyle, outObj);
	};
	
	
	DatePicker.DOM.renderYearsView = function(state) {
	
		var totalYears = 20;
		var yearsHor = 4;
		var beginYear = Math.floor(state.view.year / totalYears) * totalYears;
	
		var outObj  = [];
		var horObj = [];
		for (var yearCnt = 0; yearCnt < totalYears; yearCnt++) {
			var currentYear = beginYear + yearCnt;
			var isDisabled = (currentYear < state.yearMin || currentYear > state.yearMax);
			var cssSelected = (currentYear == state.selected.year) ? _cls('selected') : '';
	
			var yearObj = span(
								_cls('cell') + _cls('cell-year') + cssSelected + (isDisabled ? _cls('disabled') : ''),
								{
									'data-year': currentYear,
									'onclick': isDisabled ? null : DatePicker.Events.yearClick
								},
								currentYear
								);
	
			horObj.push(yearObj);
	
			if (yearCnt % yearsHor === yearsHor - 1 || yearCnt === totalYears - 1) {
				var vertObj = div(_cls('grid-row'), horObj);
				outObj.push(vertObj);
				horObj = [];
			}
		}
	
		// Whether we are in the right viewmode
		var displayStyle = '';
		if (state.viewTimeSpan.type != 'years') {
			displayStyle = _cls('hide');
		}
	
		return div( _cls('view-years') + displayStyle, outObj);
	};
	
	/* ----------- Event Handlers ----------- */
	
	DatePicker.Events.cancelButtonClick = function(event) {
		var state = DatePicker.State.getByNode(event.target);
		var node = event.target.closest(DatePicker.varants.CSSPrefix);
		var data = {node: node, state: state, instanceID: state.instanceID};
		return state.hooks.onCancel(data);
	};
	
	DatePicker.Events.saveButtonClick = function(event) {
		var state = DatePicker.State.getByNode(event.target);
		var node = event.target.closest(DatePicker.varants.CSSPrefix);
		var data = {node: node, state: state, instanceID: state.instanceID};
		return state.hooks.onSave(data);
	};
	
	DatePicker.Events.yearClick = function(event) {
		var state = DatePicker.State.getByNode(event.target);
		var date = state.view.obj.clone().year(this.dataset.year);
	
		state.viewTimeSpan = {type: 'year', delta: 1};
		state.view = DatePicker.Util.splitDateParts(date);
	
		DatePicker.State.set(state.instanceID, state);
		DatePicker.Public.redraw(state.instanceID);
	};
	
	DatePicker.Events.monthClick = function(event) {
		var state = DatePicker.State.getByNode(event.target);
		var month = parseInt(this.dataset.month) -1;
		var date = state.view.obj.clone().month(month);
	
		state.viewTimeSpan = {type: 'month', delta: 1};
		state.view = DatePicker.Util.splitDateParts(date);
	
		DatePicker.State.set(state.instanceID, state);
		DatePicker.Public.redraw(state.instanceID);
	};
	
	DatePicker.Events.dayClick = function(event) {
		var state = DatePicker.State.getByNode(event.target);
		// volgorde van aanpassen datum is hier heel erg belangrijk!
		// als we eerst dag aanpassen dan kan het voorkomen dat het niet voorkomt in huidige maand en
		// wordt het omgezet naar eerst volgende dag, waardoor aanpassen van rest van de datum niet klopt.
		// 1 april omzetten naar 31 maart, werd hierdoor 1 maart..
		// vandaar dat we beginnen met jaar, maand en dan pas dag.
		var date = state.view.obj.clone().year(this.dataset.year).month(this.dataset.month-1).date(this.dataset.day);
		DatePicker.Util.selectDate(date);
		DatePicker.Public.redraw(state.instanceID);
	};
	
	DatePicker.Events.hourClick = function(event) {
		var state = DatePicker.State.getByNode(event.target);
		var date = state.selected.obj.clone().hour(this.dataset.hour);
		DatePicker.Util.selectDate(date);
		DatePicker.Public.redraw(state.instanceID);
	};
	
	DatePicker.Events.minuteClick = function(event) {
		var state = DatePicker.State.getByNode(event.target);
		var date = state.selected.obj.clone().minute(this.dataset.minutes);
		DatePicker.Util.selectDate(date);
		DatePicker.Public.redraw(state.instanceID);
	};
	
	DatePicker.Events.presetAbsoluteDateClick = function(event) {
		
		var state = DatePicker.State.getByNode(event.target);
		var element = event.target;
		
		var preset = '';
		
		for (var key in state.presets.fixed) {
			if (state.presets.fixed[key].name === element.dataset.name) {
				preset = state.presets.fixed[key];
			}
		}
		
		if (preset) {
			var newDate = preset.fn(state.selected.obj || moment());
			DatePicker.Util.selectDate(newDate);
			DatePicker.Public.redraw(state.instanceID);
		}
	};
	
	DatePicker.Events.presetRelativeDateClick = function(event) {
		
		var state = DatePicker.State.getByNode(event.target);
		
		// if a relative preset was clicked on the start date, then we want to set the end date
		if (state.selectedDateIdx == 0) {
			state.selectedDate = state.dates[1];
			state.selectedDateIdx = 1;
		}
	
		// Relative presets
		var date = (state.dates[0].date || moment())
				   .clone()
				   .add(this.dataset.amount, this.dataset.type);
	
		DatePicker.Util.selectDate(date);
		DatePicker.Public.redraw(state.instanceID);
	};
	
	DatePicker.Events.dateTabClick = function(event) {
		var state = DatePicker.State.getByNode(event.target);
		var data = this.dataset;
		
		state.dates.forEach(function(date, index) {
			if (date.propName == data.propname) {
				state.selectedDate    = state.dates[index];
				state.selectedDateIdx = index;
				return;
			}
		});

		state.selected = DatePicker.Util.splitDateParts(state.selectedDate.date || moment());
		
		DatePicker.Util.selectDate(state.selectedDate.date);
		
		state.viewTimeSpan = {type: 'month', delta: 1};
		DatePicker.Public.redraw(state.instanceID);
	};
	
	DatePicker.Events.clearBtnClick = function(event) {
		event.preventDefault();
		event.stopPropagation();
	
		var state = DatePicker.State.getByNode(event.target);
		var propName = event.target.closest(_cls('tab')).dataset.propname;
		
		// which date index we want to clear
		var clearIndex;
		state.dates.forEach(function(date, index) {
			if (date.propName == propName) {
				state.dates[index].date = null;
				clearIndex = index;
				return;
			}
		});
		
		DatePicker.DOM.updateInputField("", clearIndex);
		
		if (state.hooks && state.hooks.onSelect !== null) {
			var node = document.getElementById(state.instanceID);
			var date = state.selectedDate;
			var data = {node: node, date: date};
			state.hooks.onSelect(data);
		}
	
		DatePicker.Public.redraw(state.instanceID);
	};
	
	DatePicker.Events.nextButtonClick = function(event) {
		var state = DatePicker.State.getByNode(event.target);
	
		// Depending on which view we are in, we want to skip months, years or 20 years
		var date = state.view.obj.clone().add(state.viewTimeSpan.delta , state.viewTimeSpan.type);
		
		state.view = DatePicker.Util.splitDateParts(date);
		DatePicker.State.set(state.instanceID, state);
		DatePicker.Public.redraw(state.instanceID);
	};
	
	DatePicker.Events.prevButtonClick = function(event) {
		var state = DatePicker.State.getByNode(event.target);
	
		// Depending on which view we are in, we want to skip months, years or 20 years
		var date = state.view.obj.clone().add(-state.viewTimeSpan.delta, state.viewTimeSpan.type);
	
		state.view = DatePicker.Util.splitDateParts(date);
		DatePicker.State.set(state.instanceID, state);
		DatePicker.Public.redraw(state.instanceID);
	};
	
	DatePicker.Events.monthTitleClick = function(event) {
		var state = DatePicker.State.getByNode(event.target);

		state.viewTimeSpan = { type: 'year', delta: 1};
		DatePicker.Public.redraw(state.instanceID);
	};
	
	DatePicker.Events.yearTitleClick = function(event) {
		var state = DatePicker.State.getByNode(event.target);
	
		state.viewTimeSpan = { type: 'years', delta: 20};
		DatePicker.Public.redraw(state.instanceID);
	};
	
	DatePicker.Events.showAllDay = function(event, date) {
		var state = DatePicker.State.getByNode(event.target);
		
		//Hide time container
		state.showTime = !state.showTime;
		
		//Update inputs to YYYY-MM-DD
		var inputFieldsNr = state.inputIDs.length;
		for (var AllinputFields = 0; AllinputFields < inputFieldsNr; AllinputFields++) {
			DatePicker.DOM.updateInputField(state.dates[AllinputFields].date, AllinputFields);
		}
		
		DatePicker.Public.redraw(state.instanceID);
	};
	
	DatePicker.DOM.renderPresetsView = function(state, allDayActive) {
	
		var presets = state.presets;
	
		allDayActive = '';
		if (!state.showTime) allDayActive = '-active';

		var presetAllDay = a(_cls('allDay' + allDayActive),
			label('All Day'), {onclick: DatePicker.Events.showAllDay}
		);
		
		// Check if in From of To mode.
		var absoluteTitle = 'From:';
		if (state.selectedDateIdx !== 0) {
			absoluteTitle = 'To:';
		}
		
		var presetTitleAbsolute = a(_cls('preset-title'), absoluteTitle);
		
		var presetTitleRelative = a(_cls('preset-title'), 'Duration:');
		
		// bij een enkele datumprikker laten we alleen de absolute presets zien
		// bij een start / eind datum prikker laten de absolute en relatieve presets zien
			if (state.showAbsolutePresets) {
				var presetStart = presets.fixed.filter(preset => {
					if (!state.showTime) {
						return preset.type !== 'time';
					} else {
						return preset.type;
					}
				}).map(function(preset) {
					return a(_cls('preset'),
						{
							'data-name': preset.name,
						},
						preset.name,
						{onclick: DatePicker.Events.presetAbsoluteDateClick}
					);
				});
			}
		
			//als de startdatum is geselecteerd en we een einddatum hebben,
			//dan willen we de relatives preset voor de einddatum laten zien
			if (state.showRelativePresets && state.dates.length > 0) {
				
				var presetDuration = presets.relative.filter(preset => {
					if (!state.showTime) {
						return preset.type !== 'hour';
					} else {
						return preset.type;
					}
				}).map(function(preset) {
						return a(_cls('preset'),
							{
								'data-name':   preset.name,
								'data-type':   preset.type,
								'data-amount': preset.amount,
							},
							preset.name,
							{onclick: DatePicker.Events.presetRelativeDateClick}
						);
				});
			}
		
		return div(
			_cls('sidebar'),
			presetAllDay,
			span(_cls('preset-from'),
				presetTitleAbsolute,
				presetStart
			),
			span(_cls('preset-duration'),
				presetTitleRelative,
				presetDuration
			)
		);
	};
	
	DatePicker.Config.getDefaultPresets = function() {
		return {
			fixed: [
				{name: 'Now',       type: 'time', fn: function(date) {return moment();} },
				{name: 'Today',     type: 'day',  fn: function(date) {return moment().startOf('day');} },
				// {name: '09:00',     type: 'time', fn: function(date) {return moment(date).hour(9).minute(0);} },
				// {name: '18:00',     type: 'time', fn: function(date) {return moment(date).hour(18).minute(0);} },
				{name: 'Tomorrow',  type: 'day',  fn: function(date) {return moment().add(1, 'day').startOf('day');} }
				// {name: 'Next week', type: 'day',  fn: function(date) {return moment().add(1, 'week');} }
			],
			relative: [
				{name: '1 Hour',   type: 'hour',  amount: 1 },
				// {name: '9 Hours',  type: 'hour',  amount: 9 },
				{name: '1 Day',    type: 'day',   amount: 1 },
				{name: '1 Week',   type: 'week',  amount: 1 },
				{name: '1 Month',  type: 'month', amount: 1 }
			]
		};
	};
	
	DatePicker.State.getByNode = function(node) {
		node = node.closest(DatePicker.varants.CSSPrefix);
		var instanceID = DatePicker.Util.getActiveInstanceIdByNode(node);
		var state = window.iddDatePicker.instances[instanceID];
		return state;
	};
	
	DatePicker.State.get = function(instanceID) {
		if (instanceID === undefined) {
			return window.iddDatePicker;
		}
	
		return window.iddDatePicker.instances[instanceID];
	};
	
	DatePicker.State.setActiveInstanceID = function(instanceID) {
		window.iddDatePicker.activeInstanceID = instanceID;
	};
	
	DatePicker.State.getActiveInstanceID = function() {
		return window.iddDatePicker.activeInstanceID;
	};
	
	DatePicker.State.set = function(instanceID, state) {
	
		// If there is not a state created, we create one
		if ( ! window.iddDatePicker) {
			window.iddDatePicker = {
				activeInstanceID: instanceID,
				instances: {},
			};
		}
	
		window.iddDatePicker.instances[instanceID] = state;
		return window.iddDatePicker;
	};
	
	
	// Make object with formatted dates from moment object
	DatePicker.Util.splitDateParts = function(time) {
	
		if (time == null) {
			return null;
		}
	
		return {
			obj:       time,
			year:      time.year(),
			month:     time.month() + 1,
			monthName: time.format('MMMM'),
			day:       time.date(),
			hour:      time.hour(),
			minutes:   time.minute(),
			YMD:       time.format('YYYY-MM-DD'),
		};
	};
	
	
	DatePicker.Util.getActiveInstanceIdByNode = function getInstanceID(node) {
		node = node.closest(DatePicker.varants.CSSPrefix);
		if (node.dataset.id) {
			var instanceID = node.dataset.id;
			window.iddDatePicker.activeInstanceId = instanceID;
			return instanceID;
		} else {
			return null;
		}
	};
	
	
	DatePicker.Util.selectDate = function(date) {
		var instanceID = DatePicker.State.getActiveInstanceID();
		var state = DatePicker.State.get(instanceID);
		
		if (date !== null) {
			
			// if we shift the start date, we want to shift the end date as well the same amount.
			// Explicit request by chefren (dont ask)
			if (state.dates.length > 1 && state.dates[1].date !== null) {
				var diff = date - state.selected.obj;
				
				var newEnd = state.dates[1].date.add(diff);
				
				// update the end field
				// (yes, it is a bit weird to update the end field before the start field)
				DatePicker.DOM.updateInputField(newEnd, 1);
			}
			
			// Make it impossible to set end date after start date.
			if (state.dates[1] && state.dates[0].date > state.dates[1].date) {
				var sameDate = state.dates[1].date - state.dates[0].date;
				var newStart = state.dates[0].date.add(sameDate);
				DatePicker.DOM.updateInputField(newStart, 1);
			}
			
			// set the selected state to the date you just clicked
			state.selected = DatePicker.Util.splitDateParts(moment(date));
			state.view = state.selected;
			state.dates[state.selectedDateIdx].date = state.selected.obj;
			DatePicker.State.set(instanceID, state);
			
			// update the input field
			DatePicker.DOM.updateInputField(date, state.selectedDateIdx);
		}
	
		if (state.hooks && state.hooks.onSelect !== null) {
			var node = document.getElementById(instanceID);
			var date = state.selectedDate;
			var data = {node: node, date: date};
			state.hooks.onSelect(data);
		}
	
	};
	
	
	// Calculate the position of the calendar container relative to the element that triggers it.
	DatePicker.Util.calculateCalenderPos = function(inputField) {
	
		var instanceID = DatePicker.State.getActiveInstanceID();
		var state = DatePicker.State.get(instanceID);
		
		var datepickerElement = document.getElementById(instanceID);
		var datePickerCoordinates = datepickerElement.getBoundingClientRect();
		
		var inputFieldCoordinates = inputField.getBoundingClientRect();
		var bodyCoordinates = document.body.getBoundingClientRect();
		
		// place the datepicker under the input field
		var top = inputFieldCoordinates.bottom - bodyCoordinates.top;
		var left = inputFieldCoordinates.left;
		
		// If there is not enough space under the input element, set the datepicker on top of the input field
		if (inputFieldCoordinates.top + datePickerCoordinates.height > window.innerHeight) {
			top = inputFieldCoordinates.top - bodyCoordinates.top - datePickerCoordinates.height;
		}
		
		// If there is not enough space on the right side of the datepicker, place it on the left side
		if (bodyCoordinates.width < datePickerCoordinates.width + left) {
			//left = inputFieldCoordinates.right - datePickerCoordinates.width;
		}
		
		state.position.top = top;
		state.position.left = left;
	};
	
	
	// Make leading zeros of integer // Example: pad0(9)  returns '09'
	DatePicker.Util.pad0 = function(number) {
		var s = number + '';
		if (s.length === 1) {
			return '0' + s;
		}
		return s;
	};
	
	DatePicker.Util.createClassName = function(name) {
		return DatePicker.varants.CSSPrefix + '-' + name;
	};
	var _cls = DatePicker.Util.createClassName;
	
	
	// function checks if a node has a parent
	function containsParent(node, parent) {
		while (node) {
			node = node.parentNode;
			
			if (node == parent) {
				return true;
			}
		}
		
		return false;
	}
	

	/**
	 * Controleerd of gevonden value geldig is en begrens
	 * 
	 * Als value ongeldig is bij:
	 * Laden van pagina           = zet datum naar vandaag.
	 * Live invoeren:             = markeer input rood.
	 * Verlaten input/datepicker: = zet datum naar vandaag.
	 **/
	DatePicker.Util.validateInput = function(inputID) {
		// Vind element bij gegeven ID
		var selectedInput = document.getElementById(inputID);
		
		// Alleen gegeven data checken.
		if (selectedInput.value != '') {

			// Controleer welke date format er gebruikt wordt.
			var format = 'YYYY-MM-DD HH:mm';
			if (selectedInput.classList.contains("idd-datepicker-time")){
				format = 'HH:mm';
			} else if (selectedInput.classList.contains("idd-datepicker-date")) {
				format = 'YYYY-MM-DD';
			}
			
			// Controleer live of invoer geldig is en geef feedback door middel van markeren input.
			selectedInput.oninput = (evt) => {
				selectedInput.classList.toggle('invalidValue', !moment(evt.target.value).isValid());
			};

			var date = moment(selectedInput.value);

			// Bij ongeldige invoer de datum naar vandaag zetten.
			if (!date.isValid()) {
				date = moment().startOf('day');
			}
			// Begrens datum
			var yearMin = DatePicker.Config.opts.yearMin;
			if (date.year() < yearMin) {
				date = moment().year(yearMin).startOf('year');
			} else {
				var yearMax = DatePicker.Config.opts.yearMax;
				if (date.year() > yearMax) {
					date = moment().year(yearMax).endOf('year');
				}
			}
			// Opgeschoonde data terugplaatsen
			selectedInput.value = date.format(format);

			// Altijd class aan het eind van deze functie verwijderen.
			// Omdat de invoer geldig is of naar vandaag is gezet en daarom ook geldig.
			selectedInput.classList.remove('invalidValue');
		}
	};
	
	// automatic datepicker generation
	//selecteer hier alleen de input type=text want er is door idd_editfield ook een type=checkbox met dezelfde class
	// een datepicker op een checkbox is licht idioot (textarea zou-nog-kunnen-maar)
	document.querySelectorAll('input[type="text"].idd-datepicker-date').forEach(function(element) {
		autoDatePickerGeneration('date', element);
		doNotZoomOnFocus(element);
	});
	
	document.querySelectorAll('input[type="text"].idd-datepicker-datetime').forEach(function(element) {
		autoDatePickerGeneration('datetime', element);
		doNotZoomOnFocus(element);
	});
	
	document.querySelectorAll('input[type="text"].idd-datepicker-time').forEach(function(element) {
		autoDatePickerGeneration('time', element);
		doNotZoomOnFocus(element);
	});
	
	
	// iOs scale problem
	// als je mobiel bent en je drukt op een input veld, dan gaat safari inzoomen op dat input veld
	// dit kan je verhelpen als de font-size minimaal 16px is ('want dan is het groot genoeg dus hoef je niet te zoomen')
	// we willen niet persee dat die input ook echt 16px groot wordt, dus we scalen hem terug met een css3-transform
	// https://stackoverflow.com/questions/2989263/disable-auto-zoom-in-input-text-tag-safari-on-iphone
	// https://codepen.io/jakob-e/pen/yakBwJ
	// (misschien betere manier: https://www.queness.com/post/17599/prevent-ios-from-zooming-form-when-fields-are-in-focus)
	function doNotZoomOnFocus(element) {
		if (/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
			element.style.fontSize = '16px';
		}
	}


	// functie die aumatisch datepickers maakt van input velden die een bepaalde class hebben (zie code hierboven).
	// in de html kan je ook opties meegeven, via het data attribute.
	// voor agenda doeleinden doen we dat, daar geven we bijvoorbeeld 'data-idd-datepicker-end-id' mee om aan te geven
	// dat dit input veld bij een start / eind datumprikker hoort
	function autoDatePickerGeneration(datePickerType, element) {
		
		// bij een start / eind datum prikker gaan we de eind datum prikker niet weergeven
		if ('iddDatepickerStartId' in element.dataset) {
			return false;
		}
		
		if (element.id == "" || element.id === undefined) {
			element.id = 'datepicker_input'+DatePicker.Config._datePickerCounter;
		}
		
		
		// standaard de huidige datum kiezen
		var initDate = moment();

		// als er al iets is ingevuld en het iets niet 0000-00-00, dan die parsen en invullen.
		// Anders DatePicker.Util.validateInput() er overheen en vandaag terug geven.
		if (element.value != '' && element.value != '0000-00-00') {
			if (datePickerType == 'time') {
				
				// (zie ook intro)
				// momentJS (of eigenlijk JS in het algemeen) kan niet goed omgaan met een tijd zonder datum.
				// daarom kiezen we de datum van vandaag, en zetten we de tijd goed.
				// in de rest van de code houden we hier natuurlijk rekening mee, dat we alleen de tijd gaan uitlezen!
				var timeDate = moment(element.value, 'HH:mm');
				initDate = initDate.hour(timeDate.hour());
				initDate = initDate.minute(timeDate.minute());
				
			} else {
				initDate = moment(element.value);
				if (!initDate.isValid()) {
					var timestamp = strtotime.strtotime(element.value);
					if (timestamp != 0) {
						initDate = moment.unix(timestamp);
					} else {
						initDate = moment();
					}
				}
			}
		}
		
		var opts = {
			inputIDs: [element.id],
			dates: [{
				name:      'Date',
				propName:  'date',
				date:      initDate,
				colors:    {color: 'white', background: 'hsl(210, 100%, 50%)'},
			}],
			showDatePanel: false,
		};
		
		// limieten van html-attributes data-year-min en data-year-max
		if ('yearMin' in element.dataset) {
			var yearMin = parseInt(element.dataset.yearMin);
			if (!isNaN(yearMin)) opts.yearMin = yearMin;
		}
		if ('yearMax' in element.dataset) {
			var yearMax = parseInt(element.dataset.yearMax);
			if (!isNaN(yearMax)) opts.yearMax = yearMax;
		}

		// validate start prikker
		opts = DatePicker.Config.validateAndMergeDefaults(opts);

		DatePicker.Util.validateInput(element.id);
		
		// bij een start / eind datum prikker gaan we maar 1 datepicker afbeelden.
		// dat doen we bij alleen bij de startdatum (zie bovenaan deze functie)
		// omdat we de eind datumprikker niet weergeven, moeten we deze als optie aan de start datum koppelen
		if (element.dataset.iddDatepickerEndId !== undefined) {
			
			var endID = element.dataset.iddDatepickerEndId;

			DatePicker.Util.validateInput(endID);

			var endDate = moment(document.getElementById(endID).value);
			
			if (!endDate.isValid()) endDate = initDate;
			
			opts.inputIDs.push(endID);
			
			opts.dates[0].name = "From";
			
			opts.dates.push({name:          'To', 
			                 propName:      'endDate', 
			                 date:           endDate, 
			                 colors:         {color: 'white', background: 'coral'},
			                 presetRelative: true});
			
			opts.showDatePanel  = true;
			opts.defaultPresets = true;
			
			// de meeste start / eind datum input velden staan onder elkaar
			// omdat je vanuit de datepicker ook het andere veld kan veranderen, wil je dat andere veld ook kunnen zien
			opts.align = 'right';
		}
		
		switch (datePickerType) {
		case 'date':
			opts.showTime = false;
			opts.showDate = true;
			break;
		case 'datetime': 
			opts.showTime = true;
			opts.showDate = true;
			break;
		case 'time':
			opts.showTime = true;
			opts.showDate = false;
			break;
		}
		
		// create datepicker
		DatePicker.Public.render(opts);
	}
	
	return DatePicker.Public;
}));
